const state = {
  user: '',
  selectedTab: 'reservations',
  windowData: {},
  lang: '',
  upcomingReservations: [],
  upcomingPaginationPage: 1,
  pastReservations: [],
  pastPaginationPage: 1,
  favourites: [],
  favouritesPaginationPage: 1,
  rewards: [],
  activeVouchers: [],
  inactiveVouchers: [],
  activeVouchersPaginationPage: 1,
  inactiveVouchersPaginationPage: 1,
  rewardsPaginationPage: 1,
  loadUser: true,
  loadUpcommingReservations: true,
  loadPastReservations: true,
  loadFavourites: true,
  loadRewards: true
}

export default state